































import {Vue, Component, Ref, Prop, PropSync} from 'vue-property-decorator';
import {Action, Getter} from "vuex-class";
import {SelectWings} from "@/components";
import { CollapseTransition } from "vue2-transitions";
import {notifyError} from "@/utils/notify-helper";
import {UploadCallSoundItem} from "@/store/call/sound/types";
import {readFileAsBinary} from "@/utils/download-helper"

@Component({components: {CollapseTransition,SelectWings}})
export default class ImportCallSounds extends Vue {
  @Ref('validator') validator: any;
  @PropSync('show') is_show!: boolean;
  @Getter("callSounds") callSounds: any;
  @Action("saveCallSound") actionImport: any;
  @Action("getCallSounds") actionGetCallSounds: any;

  private importRequest:UploadCallSoundItem = {
    name:undefined,
    file:undefined,
  };

  onFileUpload (evt:any) {
    this.importRequest.file = evt[0]
  }

  async upload():Promise<void> {
    if (!await this.validator.validate()) {
      notifyError(null, this.validator.errors)
      return
    }
    if (this.callSounds.find((item:any) => item.name == this.importRequest.name)) {
      notifyError(null, null, this.$t('template.call_sound.exist').toString())
      return
    }
    try {
      const fileString = await readFileAsBinary(this.importRequest.file)
      await this.actionImport({
        name: this.importRequest.name,
        fileData: btoa(fileString),
      });
      this.importRequest.name = undefined
      this.importRequest.file = undefined
      this.actionGetCallSounds();
    } catch (error) {
      console.log('error', error)
      notifyError(error);
    }
  }
}
